import { hexToRgbA, getLightenColor, getDarkenColor } from "./"

export default (type, colors) => {
  const styles = {
    default: {
      "site-header": {
        customCSS: `
          .view--has-chrome .site-header {
            background: ${colors.light};
          }
          .view--has-chrome .site-header__nav-col--language a.badge {
            color: ${getLightenColor(colors.secondary, 0.27)};
          }
          @media screen and (min-width: 64em) {
            .view--has-chrome .site-header__nav-dropdown-wrapper > a:first-child:after {
              content: "\\EA07";
              margin-top: 5px;
              font-size: 16px;
              background-image: none;
              line-height: normal;
              font-family: "mmo-iconfont" !important;
              position: relative;
              bottom: -4px;
            }
          }
        `
      },
      "site-header__col-inner": {
        customCSS: `
          .site-header__nav-holder .site-header__col-inner {
            background-color: ${colors.secondary};
            box-shadow: 1px 1px 0 0 ${colors.secondary};
          }
        `
      },
      "site-header__nav-link": {
        customCSS: `
          .site-header__nav-link {
            color: ${colors.secondary_dark};
          }
          .site-header__nav-link,
          .site-header__nav-link:active,
          .site-header__nav-link:focus {
            color: ${getDarkenColor(colors.secondary_dark, 0.2)};
          }
          .view--has-chrome .site-header__nav-link--profile a {
            color: ${colors.primary};
          }
          .view--has-chrome .site-header__nav-link--profile a:hover,
          .view--has-chrome .site-header__nav-link--profile a:active,
          .view--has-chrome .site-header__nav-link--profile a:focus {
            color: ${getDarkenColor(colors.primary, 0.07)};
          }

          .site-header__nav--secondary:before,
          .site-header__nav--secondary:after {
            background: ${getLightenColor(colors.primary, 0.5)}
          }

          @media screen and (max-width: 64em) {
            .view--has-chrome .site-header__nav-link:hover,
            .view--has-chrome .site-header__nav-link:active,
            .view--has-chrome .site-header__nav-link:focus {
              color: ${colors.offgray_mid};
            }
          }
        `
      },
      "site-header__nav-dropdown": {
        boxShadow: `5px 5px 50px 0 ${hexToRgbA(colors.primary, 0.2)}`,
        borderColor: colors.secondary_dark
      },
      "site-header__nav-trigger": {
        customCSS: `
          [data-whatinput=mouse] .site-header__nav-trigger:hover {
            background-color: ${getDarkenColor(colors.secondary, 0.05)};
          }
        `
      }
    },
    type1: {
      "site-header": {
        background: colors.light,
        // boxShadow: `0px 3px 5px ${hexToRgbA(colors.dark, 0.05)}`,
        transition: "0.3s all",
        borderBottom: "1px solid rgba(168, 172, 184, 0.35)",
        customCSS: `
          .view--has-chrome .site-header__inner {
            border: none;
          }

          .view--has-chrome .site-header__col.site-header__col--search {
            max-width: calc(326px + 60px);
            margin-right: auto;
          }

          .state-site-nav-expanded .site-header__nav-holder .site-header__col-inner {
            background-color: ${colors.light};
            box-shadow: none;
            box-shadow: 0px 4px 10px ${hexToRgbA(colors.dark, 0.09)};
            top: 0;
            max-width: 100vw;
            right: -30px;
          }

          .view--has-chrome .site-header__nav-col--language a.badge {
            color: ${getLightenColor(colors.secondary, 0.27)};
          }

          @media screen and (max-width: 64em) {
            .site-header__nav-mob-scroller {
              padding-top: 60px;
            }
            .site-header__nav-col {
              padding: 0!important;
            }

            .state-site-nav-expanded .site-header .site-header__nav-link,
            .state-site-nav-expanded .site-header .site-header__nav-link:hover,
            .state-site-nav-expanded .site-header .site-header__nav-link:active {
              color: ${colors.dark};
            }

            .state-site-nav-expanded .site-header .site-header__nav--social .site-header__nav-link {
              color: ${colors.primary};
            }

            .site-header__nav-link span,
            .site-header__nav-link p,
            .site-header__nav-link a,
            .site-header__nav-link em {
              font-weight: normal!important;
            }
          }

          @media screen and (max-width: 32em) {
            .site-header__nav-mob-scroller {
              width: 100%;
            }

            .site-header__col--logo .site-header__col-inner, .site-header__col--logo {
              max-width: 110px!important;
            }
          }

          @media screen and (min-width: 64em) {
            .view--has-chrome .site-header__nav-dropdown-wrapper a:first-child:after {
              width: 6px;
              height: 6px;
              border-left: 3px solid transparent;
              border-right: 3px solid transparent;
              border-top: 3px solid ${colors.primary};
              margin-top: 5px;
              background-image: none;
              margin-left: 5px;
            }
            .view--has-chrome .site-header__nav-dropdown-wrapper a.site-header__nav-link--main[href=\"/search\"]:first-child:after {
              content: '\\EA07';
              font-family: moon-iconfont!important;
              position: absolute;
              right: -20px;
              top: 6px;
              font-size: 8px;
              color: ${colors.primary};
              width: auto;
              height: auto;
              border: none;
              margin: 0;
              padding: 0;
              background: none;
              font-weight: bold;
            }
            .view--has-chrome .site-header__nav-col--language a.badge {
              color: ${colors.primary};
            }
          }
        `
      },
      "site-header__container": {
        maxWidth: "100%",
        paddingLeft: "0.83333rem",
        paddingRight: "0.83333rem"
      },
      "site-header__nav-trigger": {
        customCSS: `
          .site-header__nav-holder .site-header__col-inner {
            background-color: ${colors.primary}
          }
          .site-header__nav-holder .site-header__nav-trigger:hover {
            background-color: ${getLightenColor(colors.primary, 0.15)}
          }
          .state-site-nav-expanded .site-header__nav-holder .site-header__col-inner,
          .state-site-nav-expanded .c-button-close:hover {
            background-color: ${colors.light};
          }
          .state-site-nav-expanded .c-button-close {
            right: 20px;
            top: 20px;
          }
          .state-site-nav-expanded .c-button-close span:before,
          .state-site-nav-expanded .c-button-close span:after {
            background: #C4C4C4;
          }
        `
      },
      "site-header__col": {
        border: "none",
        customCSS: `
          .view--has-chrome .site-header__col.site-header__col--search {
            max-width: calc(470px + 60px);
          }
        `
      },
      "site-header__nav--social": {
        marginLeft: "1%",
        marginRight: "1%"
      },
      "site-header__col-inner--logo": {
        width: "auto"
      },
      "site-header__col--logo": {
        width: "auto"
      },
      "site-header__col--nav": {
        fontFamily: "Helvetica-Neue-LT-Std",
        fontSize: "14px"
      },
      "site-header__col-inner": {
        customCSS: `
          .site-header__nav-holder .site-header__col-inner {
            background-color: ${colors.secondary};
            box-shadow: 1px 1px 0 0 ${colors.secondary};
          }
          @media screen and (min-width: 32em) {
            width: auto;
          }
        `
      },
      "site-header__nav-col": {
        border: "none",
        padding: "0 40px"
      },
      "site-header__nav-col--login-block": {
        borderColor: "rgba(168, 172, 184, 0.35)"
      },
      "site-header__nav-dropdown": {
        borderTop: "none",
        boxShadow: `0px 4px 10px ${hexToRgbA(colors.dark, 0.09)}`
      },
      "site-header__nav-link--main": {
        customCSS: `
          .site-header__nav-link--main span span:first-of-type {
            display: none;
          }
        `
      },
      "site-header__nav-link": {
        fontSize: "16px",
        lineHeight: "18px",
        customCSS: `
          .site-header__nav-link,
          .site-header__nav-link:hover,
          .view--has-chrome .site-header__nav-link--profile a {
            color: ${colors.primary};
          }

          .view--has-chrome .site-header__nav-link--profile a:hover,
          .view--has-chrome .site-header__nav-link--profile a:active,
          .view--has-chrome .site-header__nav-link--profile a:focus,  {
            color: ${getDarkenColor(colors.primary, 0.07)};
          }

          .state-site-nav-expanded .site-header__nav-link {
            font-size: 16px;
            padding: 12px 0;
          }

          .state-site-nav-expanded .site-header__nav-link--secondary {
            padding: 5px 0;
            font-size: 14px;
            font-weight: bold;
          }

          .site-header__nav-link p,
          .site-header__nav-link br {
            display: none;
          }

          .site-header__nav-link span,
          .site-header__nav-link p,
          .site-header__nav-link a,
          .site-header__nav-link em {
            font-style: normal;
            letter-spacing: normal;
            line-height: normal;
            font-weight: bold;
            -webkit-font-smoothing: auto;
          }

          .site-header__nav--secondary:before,
          .site-header__nav--secondary:after {
            background: ${getLightenColor(colors.primary, 0.5)}
          }

          .state-site-nav-expanded .site-header__nav-link {
            color: ${colors.primary};
          }

          .state-site-nav-expanded .site-header__nav.site-header__nav--secondary:before,
          .state-site-nav-expanded .site-header__nav.site-header__nav--secondary:after {
            display: none;
          }

          .site-header__nav-link--profile {
            display: flex;
            align-items: center;
          }

          .state-site-nav-expanded .site-header__nav-link--profile {
            display: none;
          }

          .state-site-nav-expanded .site-header__nav-link:hover,
          .state-site-nav-expanded .site-header__nav-link:active,
          .state-site-nav-expanded .site-header__nav-link:focus {
            color: ${getDarkenColor(colors.primary, 0.23)};
          }
        `
      },
      "site-header__nav-link--profile__icon": {
        color: " #E6E6E6" /* TODO should be replaced */,
        borderRadius: "50%",
        position: "relative",
        marginRight: "8px !important",
        customCSS: `
          .site-header__nav-link--profile .icon {
            font-size: 41px!important;
            height: 41px;
            color: ${colors.secondary};
          }
          .site-header__nav-link--profile .icon:before {
            z-index: 99;
            position: relative;
          }
          @media screen and (min-width: 64em) {
            .view--has-chrome .site-header__nav-dropdown-wrapper a.site-header__nav-link--profile:after {
              content: '\\EA07';
              font-family: moon-iconfont!important;
              position: absolute;
              right: -8px;
              top: 4px;
              font-size: 8px;
              color: ${colors.primary};
              width: auto;
              height: auto;
              border: none;
              background: none;
              font-weight: bold;
            }
          }
        `
      },
      "site-header-search__input": {
        fontSize: "18px",
        fontFamily: "Helvetica-Neue-LT-Std",
        background: "#EFEFEF" /* TODO: should be replaced */,
        boxShadow: "none !important",
        borderRadius: "6px",
        customCSS: `
          .c-search__form input::placeholder {
            color: #8E8E8E; /* TODO: should be replaced */
            font-size: 18px;
            font-family: "Helvetica-Neue-LT-Std";
            font-weight: bolt;
          }
          .c-search__form.show-add-term input {
            padding-right: 55px!important;
          }
        `
      },
      "site-header-search__button": {
        customCSS: `
          .view--has-chrome .c-search__form {
            box-shadow: none;
          }
          .view--has-chrome .c-search__form input,
          .state-search-focussed .site-header .c-search__input {
            padding-left: 55px;
            box-shadow: inset 0px 2px 9px ${hexToRgbA(colors.dark, 0.1)};
          }
          .view--has-chrome .c-search__form button i {
            color: #C4C4C4;
            font-size: 20px;
            transform: scaleX(-1);
          }
          .view--has-chrome .c-search__form button {
            box-shadow: none!important;
            border: none;
            transition: all .3s;
            position: absolute;
            width: 55px;
            background: transparent;
          }
          .view--has-chrome .c-search__form .c-search__button--add {
            right: 0;
          }
          .view--has-chrome .c-search__form .c-search__button--new {
            left: 0;
          }
          .view--has-chrome .c-search__form .c-search__button--back {
            display: none;
          }
        `
      },
      "input-group-button__search-icon": {
        color: "#8E8E8E" /* TODO: should be replaced */,
        fontSize: "16px"
      },
      "auth-site-header": {
        customCSS: `
          .auth header {
            .site-header__col-inner,
            .site-header__col--logo {
              width: 100%!important;
            }
          }
        `
      }
    }
  }

  return styles[type]
}



// WEBPACK FOOTER //
// ./webapp/styles/dynamicStyles/siteHeader.js